import { CompiledMessage } from '@lingui/core/cjs/i18n'
import { isString } from 'lodash'
import { parse } from 'messageformat-parser'

// taken from linguijs internals

function processTokens(tokens) {
  if (!tokens.filter((token) => !isString(token)).length) {
    return tokens.join('')
  }

  return tokens.map((token) => {
    if (isString(token)) {
      return token

      // # in plural case
    } else if (token.type === 'octothorpe') {
      return '#'

      // simple argument
    } else if (token.type === 'argument') {
      return [token.arg]

      // argument with custom format (date, number)
    } else if (token.type === 'function') {
      const _param = token.param && token.param.tokens[0]
      const param = typeof _param === 'string' ? _param.trim() : _param
      return [token.arg, token.key, param].filter(Boolean)
    }

    const offset = token.offset ? parseInt(token.offset) : undefined

    // complex argument with cases
    const formatProps = {}
    token.cases.forEach((item) => {
      formatProps[item.key] = processTokens(item.tokens)
    })

    return [
      token.arg,
      token.type,
      {
        offset,
        ...formatProps
      }
    ]
  })
}

export function linguiCompileMessage(message: string): CompiledMessage {
  return processTokens(parse(message))
}

function isNormalInteger(str) {
  var n = Math.floor(Number(str))
  return n !== Infinity && String(n) === str && n >= 0
}

function getPluralObjectAsString(
  pluralObj: string | Record<string, unknown> | undefined
) {
  if (typeof pluralObj === 'object') {
    let res = '\n'
    for (const [key, val] of Object.entries(pluralObj)) {
      res += `  ${isNormalInteger(key) ? `=${key}` : key} {${
        Array.isArray(val) ? val.join('') : val
      }}\n`
    }

    return res
  } else {
    return pluralObj
  }
}

export function linguiDecompileMessage(
  compiledMessage: CompiledMessage
): string {
  if (Array.isArray(compiledMessage)) {
    // this is plural

    return compiledMessage.reduce((aggVal, current) => {
      return Array.isArray(current)
        ? `${aggVal}{${current
            .map((messagePart) => {
              return getPluralObjectAsString(messagePart)
            })
            .join(', ')}}`
        : aggVal + current
    }, '') as string
  }
  return compiledMessage
}
